import { Twitter as r } from "./twitter.js";
import { Facebook as m } from "./facebook.js";
import { Linkedin as o } from "./linkedin.js";
import { Andriod as i } from "./andriod.js";
import { Apple as t } from "./apple.js";
import { Instagram as e } from "./instagram.js";
import { Github as p } from "./github.js";
import { StackOverflow as f } from "./stack-overflow.js";
import { NumberOneCircleFilled as d } from "./number-one-circle-filled.js";
import { NumberTwoCircleFilled as l } from "./number-two-circle-filled.js";
import { NumberThreeCircleFilled as S } from "./number-three-circle-filled.js";
import { NumberFourCircleFilled as g } from "./number-four-circle-filled.js";
import { NumberFiveCircleFilled as c } from "./number-five-circle-filled.js";
import { NumberSixCircleFilled as F } from "./number-six-circle-filled.js";
import { NumberSevenCircleFilled as b } from "./number-seven-circle-filled.js";
import { NumberEightCircleFilled as u } from "./number-eight-circle-filled.js";
import { NumberNineCircleFilled as N } from "./number-nine-circle-filled.js";
import { Sdg1 as C } from "./sdg-1.js";
import { Sdg2 as n } from "./sdg-2.js";
import { Sdg3 as a } from "./sdg-3.js";
import { Sdg4 as h } from "./sdg-4.js";
import { Sdg5 as k } from "./sdg-5.js";
import { Sdg6 as v } from "./sdg-6.js";
import { Sdg7 as w } from "./sdg-7.js";
import { Sdg8 as x } from "./sdg-8.js";
import { Sdg9 as T } from "./sdg-9.js";
import { Sdg10 as s } from "./sdg-10.js";
import { Sdg11 as A } from "./sdg-11.js";
import { Sdg12 as E } from "./sdg-12.js";
import { Sdg13 as O } from "./sdg-13.js";
import { Sdg14 as G } from "./sdg-14.js";
import { Sdg15 as I } from "./sdg-15.js";
import { Sdg16 as L } from "./sdg-16.js";
import { Sdg17 as j } from "./sdg-17.js";
const br = {
  Twitter: r,
  Facebook: m,
  Linkedin: o,
  Andriod: i,
  Apple: t,
  Instagram: e,
  Github: p,
  StackOverflow: f,
  NumberOneCircleFilled: d,
  NumberTwoCircleFilled: l,
  NumberThreeCircleFilled: S,
  NumberFourCircleFilled: g,
  NumberFiveCircleFilled: c,
  NumberSixCircleFilled: F,
  NumberSevenCircleFilled: b,
  NumberEightCircleFilled: u,
  NumberNineCircleFilled: N,
  Sdg1: C,
  Sdg2: n,
  Sdg3: a,
  Sdg4: h,
  Sdg5: k,
  Sdg6: v,
  Sdg7: w,
  Sdg8: x,
  Sdg9: T,
  Sdg10: s,
  Sdg11: A,
  Sdg12: E,
  Sdg13: O,
  Sdg14: G,
  Sdg15: I,
  Sdg16: L,
  Sdg17: j
};
export {
  br as Extra48
};
